import { graphql } from 'react-relay';

export const applyPossibleContentQuery = graphql`
  query applyPossibleQuery($partnerId: String!, $refundId: String!) {
    checkApplyRefund(refundId: $refundId) {
      result
      email
      lastLoginType
      errors {
        code
      }
    }
    checkApplyTritxRefund(refundId: $refundId) {
      result
      email
      lastLoginType
      errors {
        code
      }
    }
    bznavRefund {
      user {
        indis {
          refundId
          defaultFeeRate
        }
        corps {
          refundId
          defaultFeeRate
        }
      }
    }
    refundPartner(partnerId: $partnerId) {
      partnerName
      defaultFeeRate
      feeRate
      startAt
      endAt
    }
  }
`;
